"use client";

import React from "react";
import { Car, MapPin, TrainFront } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const locationData = {
  address: "1051 Budapest, Erzsébet tér 9, Magyarország",
  mapUrl: "https://maps.google.com/maps?q=Budapest%20Erzs%C3%A9bet%20t%C3%A9r%209&t=&z=15&ie=UTF8&iwloc=&output=embed"
};
const infoCards = [{
  title: "Parkolási Lehetőség",
  description: "Irodánk közelében több mélygarázs is található. Ügyfeleink részére kedvezményes parkolási kártyát biztosítunk a kényelmes ügyintézés érdekében.",
  icon: Car
}, {
  title: "Tömegközlekedés",
  description: "Központi elhelyezkedésünknek köszönhetően minden metróvonal (M1, M2, M3) sétatávolságra van, így a város bármely pontjáról gyorsan elérhet minket.",
  icon: TrainFront
}, {
  title: "A Környék",
  description: "A TRAVEL központja Budapest szívében található, ahol a modern üzleti világ és a történelmi hangulat találkozik. Ideális helyszín utazási tervei megbeszéléséhez.",
  icon: MapPin
}];
export default function DoveTrovarci() {
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223399" id="irodánk-helyszíne" className="w-full bg-background text-foreground flex flex-col">
      {}
      <div className="w-full h-[400px] md:h-[500px] lg:h-[600px] relative bg-muted border-b border-border">
        <iframe title="TRAVEL iroda elhelyezkedése a térképen" src={locationData.mapUrl} className="w-full h-full border-0 grayscale contrast-125 opacity-90 dark:opacity-70 dark:invert dark:hue-rotate-180" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
        {}
        <div className="absolute inset-0 pointer-events-none bg-primary/5 dark:bg-primary/10 mix-blend-overlay" />
      </div>

      {}
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-secondary mb-4 tracking-tight">
            Hol Talál Minket?
          </h2>
          <p className="text-lg text-muted-foreground font-default max-w-2xl mx-auto">
            Látogasson el hozzánk személyesen, és tervezzük meg együtt következő álomutazását a TRAVEL szakértőivel.
          </p>
        </div>

        <div ref={cardsRef} className={`grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 transition-all duration-1000 ease-out ${cardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {infoCards.map((card, index) => {
          const Icon = card.icon;
          return <Card key={index} data-index={index} className="bg-card border-border shadow-lg hover:shadow-xl transition-shadow duration-300 h-full flex flex-col rounded-2xl">
                <CardHeader className="pb-4">
                  <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                    <Icon className="w-6 h-6 text-primary" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="font-default text-xl md:text-2xl text-card-foreground">
                    {card.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="pt-0 flex-grow">
                  <p className="text-muted-foreground font-default leading-relaxed">
                    {card.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}